import * as echarts from "echarts";
import beijing from "./beijing.json";
echarts.registerMap('beijing', beijing);

function initChartInstance(eleId) {
    let instance = echarts.getInstanceByDom(document.getElementById(eleId))
    if (instance != null && instance != "" && instance != undefined) {
        instance.dispose();
    }
    return echarts.init(document.getElementById(eleId), "dark")
}

export function drawPie(eleId, params) {
    let myChart = initChartInstance(eleId)
    const option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        series: [
            {
                name: params.name || "数据情况",
                type: 'pie',
                radius: '70%',
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: params.data
            }
        ]
    };
    myChart.setOption(option);
    return option;
}

export function drawHxPie(eleId, params) {
    let myChart = initChartInstance(eleId)
    const option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        series: [
            {
                name: params.name || "数据情况",
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: params.data
            }
        ]
    };
    myChart.setOption(option);
    return option;
}

export function drawBar(eleId, params) {
    let myChart = initChartInstance(eleId)
    let option = {
        title: {
            show: false
        },
        tooltip: {},
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        xAxis: {
            data: params.data.map(d => d.name),
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
            }
        },
        yAxis: {},
        series: [
            {
                name: params.name || "数据情况",
                type: "bar",
                barWidth: 10,
                data: params.data
            },
        ],
    };
    myChart.setOption(option);
    return option;
}

export function drawHBar(eleId, params) {
    let myChart = initChartInstance(eleId)
    let option = {
        title: {
            show: false
        },
        tooltip: {},
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        grid:{
            containLabel:true
        },
        yAxis: {
            data: params.data.map(d => d.name),
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0
            },
        },
        xAxis: {
            // splitLine: {
            //     show: false
            // }
        },
        series: [
            {
                showBackground: true,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#83bff6' },
                        { offset: 0.5, color: '#188df0' },
                        { offset: 1, color: '#188df0' }
                    ])
                },
                name: params.name || "数据情况",
                type: "bar",
                barWidth: 10,
                data: params.data
            },
        ],
    };
    myChart.setOption(option);
    return option;
}

export function drawPolarBar(eleId, params) {
    let myChart = initChartInstance(eleId)
    let option = {
        title: {
            show: false
        },
        tooltip: {},
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        polar: {
            radius: [30, '80%']
        },
        angleAxis: {
            max: 600,
            startAngle: 90,
        },
        radiusAxis: {
            type: 'category',
            data: params.data.map(d => d.name),
            axisLabel: {
                interval: 0
            },
        },
        series: [
            {
                name: params.name || "数据情况",
                type: "bar",
                barWidth: 5,
                coordinateSystem: 'polar',
                data: params.data
            },
        ],
    };
    myChart.setOption(option);
    return option;
}

export function drawPictorialBar(eleId, params) {
    let myChart = initChartInstance(eleId)
    const option = {
        tooltip: {
        },
        legend: {
            top: '5%',
            left: 'right',
            orient: 'vertical',
            type: 'scroll',
        },
        xAxis: {
            data: params.data.map(d => d.name),
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0
            }
        },
        yAxis: {
            splitLine: { show: false }
        },
        series: [
            {
                name: params.name || "数据情况",
                type: 'pictorialBar',
                symbolPosition: 'center',
                emphasis: {
                    scale: true
                },
                emphasis: {
                    label: {
                        show: true,
                        fontWeight: 'bold'
                    }
                },
                data: params.data
            }
        ]
    };
    myChart.setOption(option);
    return option;
}

export function drawMap(eleId, params) {
    let myChart = initChartInstance(eleId)
    var data = [
        { name: '小区1', value: 10 },
        { name: '小区2', value: 12 },
        { name: '小区3', value: 12 },
        { name: '小区4', value: 12 },
        { name: '小区5', value: 12 },
        { name: '小区6', value: 12 },
        { name: '小区7', value: 12 },
    ];
    var geoCoordMap = {
        小区1: [116.418757, 39.917544],
        小区2: [116.618757, 39.517544],
        小区3: [115.818757, 40.417544],
        小区4: [117.418757, 39.117544],
        小区5: [116.018757, 40.217544],
        小区6: [116.618757, 40.917544],
        小区7: [117.218757, 40.317544],
    };
    var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
                res.push({
                    name: data[i].name,
                    value: geoCoord.concat(data[i].value)
                });
            }
        }
        return res;
    };
    let option = {
        title: {
            show: false
        },
        tooltip: {
            trigger: 'item'
        },
        geo: {
            map: 'beijing',
            label: {
                show: false
            },
            itemStyle: {
                areaColor: '#100c2a',
            }
        },
        series: [
            {
                name: params.name || "数据情况",
                type: 'scatter',
                coordinateSystem: 'geo',
                data: convertData(data),
                encode: {
                    value: 2
                },
                symbolSize: function (val) {
                    return val[2];
                },
                label: {
                    formatter: '{b}',
                    position: 'right'
                },
                itemStyle: {
                    color: '#ddb926'
                },
                emphasis: {
                    label: {
                        show: true
                    }
                }
            },
        ]
    };
    myChart.setOption(option);
    return option;
}

export function drawTree(eleId, params) {
    let myChart = initChartInstance(eleId)
    const option = {
        series: [
            {
                name: params.name || "数据情况",
                type: 'tree',
                data: [params.data],
                symbol: 'emptyCircle',
                orient: 'vertical',
                expandAndCollapse: true,
                animationDurationUpdate: 750,
                label: {
                    fontFamily: "Microsoft YaHei",
                    verticalAlign: 'middle',
                }
            }
        ]
    };
    myChart.setOption(option);
    return option;
}